import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import styles from "./index.module.css";
export const PopupTextarea = ({ name, value, setInput, autoFocus = false, }) => {
    const id = useId();
    return (_jsxs("div", { className: styles.textareaWrapper, children: [_jsx("textarea", { className: styles.textarea, id: id, value: value, onChange: (event) => setInput(event.target.value), autoFocus: autoFocus }), _jsx("label", { className: styles.textareaLabel, htmlFor: id, children: name })] }));
};
